<template>
    <div
        :class="[
            'ls-content-placeholder--container',
            { loading: image === 'spinner', 'fit-to-parent': fitToParent },
        ]"
    >
        <div class="ls-content-placeholder--content" test-id="content">
            <div class="ls-content-placeholder--image-wrapper">
                <img src="@/assets/gray_loading_bg.png" />
                <DotsSVG />
                <Component :is="component" />
            </div>
            <span class="ls-content-placeholder--message">{{ message }}</span>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import SpinnerSVG from './components/SpinnerSVG.vue';
import DotsSVG from './components/DotsSVG.vue';
import SearchSVG from './components/SearchSVG.vue';
import InactiveSVG from './components/InactiveSVG.vue';
import PauseSVG from './components/PauseSVG.vue';
import SelectSVG from './components/SelectSVG.vue';

export default {
    name: 'LsContentPlaceholder',
    components: {
        SpinnerSVG,
        DotsSVG,
        SearchSVG,
        InactiveSVG,
        PauseSVG,
        SelectSVG,
    },
    props: {
        message: VueTypes.string.isRequired,
        image: VueTypes.oneOf(['spinner', 'search', 'inactive', 'pause', 'select']).isRequired,
        fitToParent: VueTypes.bool.def(false),
    },
    computed: {
        component() {
            return _.get(this.$options.components, `${_.startCase(this.image)}SVG`);
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-content-placeholder--container {
    position: absolute;
    width: 100%;
    height: 100%;
    min-height: 70vh;
    border-radius: $border-radius;
    box-shadow: $box-shadow;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 230px;
    z-index: $z-ls-templated-loading-content;

    &.loading {
        background-color: rgba(255, 255, 255, 0.7);
    }

    &.fit-to-parent {
        position: inherit;
        min-height: 0;
        padding: 0;
        box-shadow: none;
    }

    .ls-content-placeholder--content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .ls-content-placeholder--image-wrapper {
        position: relative;
        height: 210px;
        user-select: none;
    }

    .ls-content-placeholder--message {
        color: $secondary-dark;
        font-size: 2.5rem;
        font-weight: $semi-bold;
        margin-top: 20px;
        text-align: center;
    }
}
</style>
